import { IGpsItemsForList } from '@nkr/models/index';
import { Button, Modal } from 'react-bootstrap';

interface IProps {
    show: boolean,
    data: IGpsItemsForList,
    onConfirm: () => void,
    onCancel: () => void,
    onLost: () => void
}

const ReturnedConfirmation = (props: IProps) => {
    let gpsNumber = props.data != null ? props.data.gpsNumber : '';

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>
                Confirm Status Change
            </Modal.Header>
            <Modal.Body>
                <span>Please confirm GPS {gpsNumber} status as either returned or lost? </span>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onCancel}>Cancel</Button>
                <Button bsStyle='primary' onClick={props.onConfirm}>Mark As Returned</Button>
                <Button bsStyle='danger' onClick={props.onLost}>Mark As Lost</Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ReturnedConfirmation;